export default {
  facilities: 'تسهیلات',
  facilitiesType: 'نوع تسهیلات',
  transactions: 'تراکنش ها',
  depositNumber: 'شماره سپرده',
  installmentsCount: 'تعداد اقساط',
  pay: 'پرداخت',
  clearing: 'تسویه',
  successfullyPaid: 'با موفقیت پرداخت شد',
  successfullyCleared: 'با موفقیت تسویه شد',
  withdrawalBalance: 'موجودی قابل برداشت',
  pleaseSelectTheDestinationBank: 'لطفا بانک مقصد را انتخاب کنید',
  withdraw: 'برداشت',
  deposit: 'واریز'
}
